import React from 'react';
import defaultConnect from '../../../../components/redux/defaultConnect';
import makeRequest from '../../../../lib/apiService';
import { WafoForm, WafoFormAutocomplete } from '@wafo/forms';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

class ModalVehiculo extends React.Component {
  state = {
    list: [],
    loaded: false,
    vehicle: {
      id_vehicle: 0,
    },
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const { setLoading, pushError, idUser } = this.props;

    try {
      setLoading(true);
      const resp = await makeRequest(
        'vehicles/?limit=99999',
        { method: 'GET' },
      );
      const list = idUser
        ? resp.rows.filter(v => v.id_user === idUser)
        : [];
      this.setState({ list, loaded: true }, () => { setLoading(false); });
    } catch (error) {
      setLoading(false);
      pushError(error.message);
    }
  }

  handleFormSubmit = async (form) => {
    const { setLoading, pushAlerta, pushError, pushSuccess, closeModal, updateTable, id } = this.props;

    if (!form.valid) {
      pushAlerta({
        type: 'warning',
        title: '¡Hay un problema!',
        message: 'Algunos de los campos en la forma tienen problemas.',
        timer: 3000,
      });
      return;
    }

    const vehicle = form.id_vehicle.value;

    try {
      setLoading(true);
      await makeRequest(
        `vehicles/${vehicle.id_vehicle}`,
        { method: 'PUT' },
        {
          key_vehicle: vehicle.key_vehicle,
          imei: vehicle.imei,
          phone_number: vehicle.phone_number,
          plate_number: vehicle.plate_number,
          description: vehicle.description,
          notes: vehicle.notes,
          id_user: vehicle.id_user,
          id_driver: parseInt(id, 10),
        },
      );
      setLoading(false);
      pushSuccess('Se han guardado los cambios.', 3000);
      updateTable();
      closeModal();
    } catch (error) {
      setLoading(false);
      pushError(error.message);
    }
  }

  render() {
    const { list, vehicle, loaded } = this.state;
    const { closeModal, idUser } = this.props;

    const emptyMessage = !idUser
      ? 'El chofer no tiene concesionario asignado. Asigna un concesionario antes de agregar vehículos.'
      : 'El concesionario no tiene vehículos registrados.';

    return (
      <div className="modal-vehicle">
        <div className="backdrop">
          <div className="card animate-in">
            <div className="card-header">
              <h5 className="modal-title">Asignar vehículo</h5>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={closeModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="card-body detalles">
              {loaded && list.length === 0 ? (
                <div className="modal-empty-state">
                  <FontAwesomeIcon icon={faExclamationCircle} className="modal-empty-icon" />
                  <p>{emptyMessage}</p>
                </div>
              ) : (
                <WafoForm
                  key={vehicle.id_vehicle}
                  buttonText="Guardar"
                  onSubmit={this.handleFormSubmit}
                  values={vehicle}
                >
                  <WafoFormAutocomplete
                    name="id_vehicle"
                    customClass="col-12"
                    label="Vehículo"
                    placeholder="Seleccione un vehículo"
                    items={list}
                    filterItemsFN={(items, query) => items.filter(item => (
                      item.key_vehicle.toLowerCase().indexOf(query.toLowerCase()) !== -1
                      || (item.plate_number && item.plate_number.toLowerCase().indexOf(query.toLowerCase()) !== -1)
                      || (item.description && item.description.toLowerCase().indexOf(query.toLowerCase()) !== -1)
                    ))}
                    customItemFN={item => `${item.key_vehicle}${item.plate_number ? ` - ${item.plate_number}` : ''}`}
                    customInputFN={item => `${item.key_vehicle}${item.plate_number ? ` - ${item.plate_number}` : ''}`}
                  />
                </WafoForm>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default defaultConnect(ModalVehiculo);
